module.exports = __webpack_public_path__ + "static/media/crook.005c19d5.png";